module.exports = __webpack_public_path__ + "85014777e1769e9feaeedda161c318a8.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/welcome/karaoke_tsm_pineapple.png
// module id = 430
// module chunks = 0